import { TZDate } from '@date-fns/tz';

/**
 * The API sends enrollment dates as a bare day serialized at UTC midnight, e.g. "2026-09-30T00:00:00.000Z".
 * Passing that to `new Date()` keeps the instant, so west of UTC it lands on the day before — which is
 * how the last day of an enrollment ends up missing from the calendar. Read the day in UTC instead and
 * rebuild it at midnight in the zone the caller compares against.
 *
 * Returns undefined if the string is not a valid date.
 */
const enrollmentDateParts = (enrollmentDate: string): [number, number, number] | undefined => {
  const parsed = new Date(enrollmentDate);

  if (Number.isNaN(parsed.getTime())) return undefined;

  return [parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate()];
};

export const enrollmentDateToLocalDay = (enrollmentDate: string): Date | undefined => {
  const parts = enrollmentDateParts(enrollmentDate);

  return parts && new Date(...parts);
};

/**
 * MYM-260: the booking calendar renders its days in the center's zone, so the enrollment
 * boundaries it compares them against have to sit at center midnight rather than device midnight.
 */
export const enrollmentDateToCenterDay = (enrollmentDate: string, timeZone: string): TZDate | undefined => {
  const parts = enrollmentDateParts(enrollmentDate);

  return parts && new TZDate(...parts, timeZone);
};
